<template>
  <PainelLayout>
    <Breadcrumb :lista="[{ 'name':'Painel', 'link' : '/' }]" />
    <h1>Relatórios</h1>
    <hr/>

    <!-- Seletor de período -->
    <div class="card filter-card border mb-4">
      <div class="card-body p-3 d-flex flex-wrap align-items-center gap-2">
        <div class="btn-group" role="group" aria-label="Período">
          <button
            v-for="preset in presets" :key="preset.key"
            type="button"
            class="btn btn-sm"
            :class="activePreset === preset.key ? 'btn-primary' : 'btn-outline-secondary'"
            @click="selectPreset(preset.key)"
          >{{ preset.label }}</button>
        </div>

        <div class="d-flex align-items-center gap-2 ms-lg-2">
          <input type="date" class="form-control form-control-sm" v-model="date_start" :max="date_end" @change="onCustomChange">
          <span class="text-secondary">até</span>
          <input type="date" class="form-control form-control-sm" v-model="date_end" :min="date_start" @change="onCustomChange">
        </div>
      </div>
    </div>

    <!--
      v-if (não v-show): a classe d-flex do Bootstrap é `display:flex !important`,
      que tem prioridade sobre o `display:none` inline que o v-show aplicaria —
      o spinner nunca sumiria. Esse bloco não guarda estado (diferente do de baixo,
      que precisa manter os canvas montados), então v-if é seguro aqui.
    -->
    <div v-if="loading" class="d-flex justify-content-center p-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!--
      v-show (não v-if/v-else): os canvas dos gráficos precisam permanecer no DOM
      entre requisições, senão a instância do Chart.js guardada em
      launchedChartInstance/completedChartInstance fica presa a um <canvas> antigo
      já destacado do DOM e o .update() deixa de ter efeito visível.
    -->
    <div v-show="!loading">
      <p class="section-label mb-3">Valores no período</p>
      <div class="row g-3 mb-4">
        <div class="col-12 col-lg-6">
          <div class="card chart-card border h-100">
            <div class="card-body p-3 d-flex flex-column">
              <p class="section-label mb-2">Locações lançadas</p>
              <div class="card-value money mb-3">R$ {{ launched.total.toFixed(2) }}</div>
              <div class="flex-grow-1" style="min-height: 240px;">
                <canvas ref="launchedChartCanvas"></canvas>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="card chart-card border h-100">
            <div class="card-body p-3 d-flex flex-column">
              <p class="section-label mb-2">Locações encerradas</p>
              <div class="card-value money mb-3">R$ {{ completed.total.toFixed(2) }}</div>
              <div class="flex-grow-1" style="min-height: 240px;">
                <canvas ref="completedChartCanvas"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="section-label mb-3">Locações — quantidade no período</p>
      <div class="row g-3">
        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card metric-card card-purple border h-100">
            <div class="card-body p-3 d-flex flex-column">
              <div class="card-icon icon-purple mb-3">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#534AB7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
              </div>
              <div class="card-value mb-1">{{ launched.quant }}</div>
              <p class="text-secondary mb-0" style="font-size:12px;">Lançadas</p>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card metric-card card-green border h-100">
            <div class="card-body p-3 d-flex flex-column">
              <div class="card-icon icon-green mb-3">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <div class="card-value mb-1">{{ completed.quant }}</div>
              <p class="text-secondary mb-0" style="font-size:12px;">Encerradas</p>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card metric-card card-amber border h-100">
            <div class="card-body p-3 d-flex flex-column">
              <div class="card-icon icon-amber mb-3">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#854F0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div class="card-value mb-1">{{ waiting_quant }}</div>
              <p class="text-secondary mb-0" style="font-size:12px;">Aguardando</p>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card metric-card card-teal border h-100">
            <div class="card-body p-3 d-flex flex-column">
              <div class="card-icon icon-teal mb-3">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="1 4 1 10 7 10"/>
                  <path d="M3.51 15a9 9 0 1 0 .49-3.6"/>
                </svg>
              </div>
              <div class="card-value mb-1">{{ active_quant }}</div>
              <p class="text-secondary mb-0" style="font-size:12px;">Em andamento</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="margin-footer"></div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { onMounted, ref, nextTick } from 'vue';
import { painel } from '@/models/painel';
import { useToastStore } from '@/stores/toastStore';
import { Chart, LineController, LineElement, PointElement, CategoryScale, LinearScale, Tooltip } from 'chart.js';

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Tooltip);

function toLocalISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
}

export default {
  name: "ReportsView",
  components: { PainelLayout, Breadcrumb },
  setup() {
    const toastStore = useToastStore();
    const painelmodel = painel();

    const launchedChartCanvas = ref(null);
    const completedChartCanvas = ref(null);
    let launchedChartInstance = null;
    let completedChartInstance = null;

    const loading = ref(true);
    const activePreset = ref('month');
    const date_start = ref('');
    const date_end = ref('');

    const launched = ref({ quant: 0, total: 0, total_por_dia: {} });
    const completed = ref({ quant: 0, total: 0, total_por_dia: {} });
    const waiting_quant = ref(0);
    const active_quant = ref(0);

    const presets = [
      { key: '7d', label: '7 dias' },
      { key: '30d', label: '30 dias' },
      { key: 'month', label: 'Mês atual' },
      { key: '90d', label: '90 dias' },
    ];

    function rangeForPreset(key) {
      const today = new Date();
      switch (key) {
        case '7d': return [daysAgo(6), today];
        case '30d': return [daysAgo(29), today];
        case '90d': return [daysAgo(89), today];
        case 'month': return [new Date(today.getFullYear(), today.getMonth(), 1), today];
        default: return [daysAgo(29), today];
      }
    }

    function selectPreset(key) {
      activePreset.value = key;
      const [start, end] = rangeForPreset(key);
      date_start.value = toLocalISODate(start);
      date_end.value = toLocalISODate(end);
      fetchReports();
    }

    function onCustomChange() {
      if (!date_start.value || !date_end.value) return;
      if (date_start.value > date_end.value) return;
      activePreset.value = null; // deixa de refletir um preset — o usuário escolheu um período livre
      fetchReports();
    }

    function formatarLabelDia(dataStr) {
      // "2026-08-08" -> "08/08"
      const partes = dataStr.split('-');
      return `${partes[2]}/${partes[1]}`;
    }

    function renderChart(canvas, existingInstance, totalPorDia, color, bgColor) {
      if (!canvas) return existingInstance;

      const labels = Object.keys(totalPorDia).map(formatarLabelDia);
      const valores = Object.values(totalPorDia);

      if (existingInstance) {
        existingInstance.data.labels = labels;
        existingInstance.data.datasets[0].data = valores;
        existingInstance.update();
        return existingInstance;
      }

      return new Chart(canvas.getContext('2d'), {
        type: 'line',
        data: {
          labels,
          datasets: [{
            label: 'Valor (R$)',
            data: valores,
            borderColor: color,
            backgroundColor: bgColor,
            pointBackgroundColor: color,
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 3,
            pointHoverRadius: 5,
            borderWidth: 2.5,
            tension: 0.35,
            fill: true
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (ctx) => `R$ ${ctx.parsed.y.toFixed(2)}`
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => `R$ ${value}`
              }
            }
          }
        }
      });
    }

    async function fetchReports() {
      loading.value = true;
      const response = await painelmodel.getReports(date_start.value, date_end.value);

      if (!response) {
        toastStore.error('Não foi possível carregar o relatório.');
        loading.value = false;
        return;
      }

      launched.value = response.launched;
      completed.value = response.completed;
      waiting_quant.value = response.waiting_quant;
      active_quant.value = response.active_quant;

      loading.value = false;
      await nextTick(); // garante que o v-else já liberou os canvas no DOM

      launchedChartInstance = renderChart(
        launchedChartCanvas.value, launchedChartInstance, launched.value.total_por_dia,
        '#534AB7', 'rgba(83, 74, 183, 0.12)'
      );
      completedChartInstance = renderChart(
        completedChartCanvas.value, completedChartInstance, completed.value.total_por_dia,
        '#3B6D11', 'rgba(59, 109, 17, 0.12)'
      );
    }

    onMounted(() => {
      selectPreset('month');
    });

    return {
      presets, activePreset, date_start, date_end, selectPreset, onCustomChange,
      loading, launched, completed, waiting_quant, active_quant,
      launchedChartCanvas, completedChartCanvas
    };
  }
}
</script>

<style scoped>

  .margin-footer {
    height: 20px;
  }

  .filter-card, .chart-card {
    border-radius: 16px !important;
    border: 0.5px solid rgba(0,0,0,0.08) !important;
  }

  .section-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #9a9a9a;
  }

  .metric-card {
    border: 0.5px solid rgba(0,0,0,0.08) !important;
    border-radius: 16px !important;
    transition: transform 0.18s ease, border-color 0.18s ease;
    overflow: hidden;
    position: relative;
  }

  .metric-card:hover {
    transform: translateY(-2px);
    border-color: rgba(0,0,0,0.18) !important;
  }

  .metric-card::before {
    content: '';
    display: block;
    height: 3px;
    width: 100%;
  }

  .card-purple::before { background: linear-gradient(90deg, #534AB7, #AFA9EC); }
  .card-amber::before  { background: linear-gradient(90deg, #BA7517, #EF9F27); }
  .card-green::before  { background: linear-gradient(90deg, #3B6D11, #97C459); }
  .card-teal::before   { background: linear-gradient(90deg, #1D9E75, #5DCAA5); }

  .card-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-purple { background: #EEEDFE; }
  .icon-amber  { background: #FAEEDA; }
  .icon-green  { background: #EAF3DE; }
  .icon-teal   { background: #E1F5EE; }

  .card-value {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1;
    letter-spacing: -0.03em;
  }

  .card-value.money {
    font-family: 'JetBrains Mono', monospace;
    font-size: 22px;
  }

</style>
